import initState from './initState';
import {
  START_CHECKOUT_REQUEST,
  FINISH_CHECKOUT_REQUEST,
  INIT_CHECKOUT_STATE,
  SET_CARPROFILE,
  SET_MOTORPROFILE,
  SET_TRAVELFILTER_FORM,
  SET_ACCIDENTFILTER_FORM,
  SET_PETFILTER_FORM,
  SET_VACCINEFILTER_FORM,
  SET_INSUINFOS,
  SET_CAR_CHECKOUT_INFO,
  SET_MOTOR_CHECKOUT_INFO,
  SET_TRAVEL_CHECKOUT_INFO,
  SET_ACCIDENT_CHECKOUT_INFO,
  SET_PET_CHECKOUT_INFO, 
  SET_VACCINE_CHECKOUT_INFO,
  SET_CHECKOUT_QUOTE_OFCAR,
  SET_CHECKOUT_QUOTE_OFTRAVEL,
  SET_CHECKOUT_QUOTE_OFACCIDENT,
  SET_CHECKOUT_QUOTE_OFPET,
  SET_CHECKOUT_QUOTE_OFVACCINE,
  SET_INSUPERIOD,
  SET_CHECKOUT_PRODPOLICIES
} from "./constants";
import { carProfile as carProfileOfCar  } from '@/utils/asyncValidator/infoOfCar';
import { carProfile as carProfileOfMotor  } from '@/utils/asyncValidator/infoOfMotor';
const finishCheckoutRequest = (state) => {
  state.loading = false;
};

const startCheckoutRequest = (state) => {
  state.loading = true;
};
const initCheckoutState = (state) => {
  state.insuInfos = [ ...initState.insuInfos ];
  state.infoOfTravel = { ...initState.infoOfTravel};
  state.infoOfCar = { ...initState.infoOfCar};
  state.infoOfMotor = { ...initState.infoOfMotor};
  state.infoOfAccident = { ...initState.infoOfAccident};
  state.infoOfPet = { ...initState.infoOfPet}; //試算條件、購物車方案傳送至資料輸入
  state.infoOfVaccine = { ...initState.infoOfVaccine};  //20210530 Wen Add
  state.loading = initState.loading;
  state.insuType = initState.insuType;
  state.quotes = {...initState.quotes};
  state.carInfo = { ...initState.carInfo };
  state.travelInsuInfo = {...initState.travelInsuInfo};
  state.accidentInsuInfo = {...initState.accidentInsuInfo};
  state.petInsuInfo = {...initState.petInsuInfo};
  state.vaccintInfo = {...initState.vaccineInsuInfo};
  //state.isbuy = initState.isbuy;
}
const setTravelFilterForm = (state, filter) => {
  state.infoOfTravel.travelFilter = { 
    ...filter,
    travelArea: [{ state: null ,country: null}],
  };
};
const setAccidentFilterForm = (state, filter) => {
  state.infoOfAccident.accidentFilter = { 
    ...filter,
    //accidentArea:'',  //20210315
    //accidentArea: [{ jobtype : null}],  //accidentArea: [{ state: null ,job: null}]    
  };
};
const setPetFilterForm = (state,  filter) => {   
  state.infoOfPet.petFilter = { 
    ...filter,       
  };    
};

//20210530 Wen Add  SET_VACCINEFILTER_FORM 
const setVaccineFilterForm = (state, filter) => {  
  state.infoOfVaccine.vaccineFilter = { 
    ...filter,       
  };
};

const setCarProfile = (state, { source, profile }) => {
  
  switch (source) {
    case 'checkout':
      const { inceptionDate, carProfile } = profile;
      state.infoOfCar.inceptionDate = { ...inceptionDate };
      state.infoOfCar.carProfile = { ...carProfile};
      break;
    case 'filter':
      const { carNo } = profile;
      state.infoOfCar.carProfile = {
        ...carProfileOfCar,
        carNo: {
          ...carNo,
          carType: ''
        }
      }
      break;
  }
}
const setMotorProfile = (state, { source, profile }) => {
  switch (source) {
    case 'checkout':
      const { inceptionDate, carProfile } = profile;
      state.infoOfMotor.inceptionDate = { ...inceptionDate };
      state.infoOfMotor.carProfile = { ...carProfile }
      break;
    case 'filter':
      const { carNo } = profile;
      state.infoOfMotor.carProfile = {
        ...carProfileOfMotor,
        carNo: {
          ...carNo,
          carType: ''
        }
      }
      break;
  }
}
const setInsuPeriod = (state , payload ) => {
  state.travelInsuInfo.insuPeriod = payload;
  state.accidentInsuInfo.AccidentinsuPeriod = payload;    
  state.petInsuInfo.PetinsuPeriod = payload;
  state.vaccineInsuInfo.VaccineinsuPeriod=payload; //2021/8/30 Wen Add
}
const setInsuInfos = (state, { infos, insuType }) => {
  state.insuType = insuType;
  state.insuInfos = [...infos];
};
const setCarCheckoutInfo = (state, checkoutInfo ) => {
  const { inceptionDate, carProfile,autoNoticeData , userProfile } = checkoutInfo;
  state.infoOfCar = {
    inceptionDate: { ...inceptionDate },
    carProfile: { ...carProfile },
    autoNoticeData: { ...autoNoticeData },
    userProfile: { ...userProfile }
  }
};
const setMotorCheckoutInfo = (state, checkoutInfo ) => {
  const { inceptionDate, carProfile,autoNoticeData , userProfile } = checkoutInfo;
  state.infoOfMotor = {
    inceptionDate: { ...inceptionDate },
    carProfile: { ...carProfile },
    autoNoticeData: { ...autoNoticeData },
    userProfile: { ...userProfile }
  }
};
const setTravelCheckoutInfo = (state, checkoutInfo ) => {
  const { 
    travelFilter,
    beneficiaryProfile,
    travelNoticeData,
    userProfile 
  } = checkoutInfo;

  state.infoOfTravel = {
    travelFilter: { ...travelFilter },
    beneficiaryProfile: { ...beneficiaryProfile },
    travelNoticeData: { ...travelNoticeData },
    userProfile: { ...userProfile }
  }
};
const setAccidentCheckoutInfo = (state, checkoutInfo ) => {
  const { 
    accidentFilter,
    accidentbeneficiaryProfile,
    accidentNoticeData,
    userProfile,
    healthNoticeData 
  } = checkoutInfo;

  state.infoOfAccident = {
    accidentFilter: { ...accidentFilter },
    accidentbeneficiaryProfile: { ...accidentbeneficiaryProfile },
    accidentNoticeData: { ...accidentNoticeData },
    userProfile: { ...userProfile },
    healthNoticeData:{  ...healthNoticeData}
  }
};

const setPetCheckoutInfo = (state, checkoutInfo ) => {
  const { 
    petFilter,
    //petBeneficiaryProfile,
    petNoticeData,
    userProfile,
    petHealthNoticeData 
  } = checkoutInfo;

  state.infoOfPet = {
    petFilter: { ...petFilter },
    //petBeneficiaryProfile: { ...petBeneficiaryProfile },
    petNoticeData: { ...petNoticeData },
    userProfile: { ...userProfile },
    petHealthNoticeData:{  ...petHealthNoticeData}
  }  
};

const setVaccineCheckoutInfo = (state, checkoutInfo ) => {
  const { 
    vaccineFilter,
    vaccineBeneficiaryProfile,
    vaccineNoticeData,
    userProfile 
  } = checkoutInfo;

  state.infoOfVaccine = {
    vaccineFilter: { ...vaccineFilter },
    vaccineBeneficiaryProfile: { ...vaccineBeneficiaryProfile },
    vaccineNoticeData: { ...vaccineNoticeData },
    userProfile: { ...userProfile }
  }
};
const setCheckoutQuoteOfCar = (state, payload ) => {
  const { carInfo,quotes } = payload;
  state.quotes = { ...quotes };
  state.carInfo = { ...carInfo };
};
const setCheckoutQuoteOfTravel = (state, payload ) => {
  const { travelInsuInfo,quotes } = payload;
  const { travelArea } = travelInsuInfo;
  state.quotes = { ...quotes };
  state.travelInsuInfo.travelArea = [ ...travelArea ];
};
const setCheckoutQuoteOfAccident = (state, payload ) => {
  const { accidentInsuInfo,quotes} = payload;
  const { accidentArea } = accidentInsuInfo;  
  state.quotes = { ...quotes };
  state.accidentInsuInfo.accidentArea = accidentArea;//{...accidentArea} ;//  20210315 
};
//設定保單確認資料
const setCheckoutQuoteOfPet = (state, payload ) => {
  const { quotes} = payload;    //2021/4/23 Wen Add
  state.quotes = { ...quotes }; 
  //state.petInsuInfo=petInsuInfo;
};

//設定保單確認資料
const setCheckoutQuoteOfVaccine = (state, payload ) => {
  const { quotes} = payload;    //20210530 Wen Add
  state.quotes = { ...quotes }; 
  //state.petInsuInfo=petInsuInfo;
};
const setCheckoutProdplicies = ( state, payload ) => {
  state.quotes.prodPolicies = [ ...payload ]; 
};

export default {
  [START_CHECKOUT_REQUEST]: startCheckoutRequest,
  [FINISH_CHECKOUT_REQUEST]: finishCheckoutRequest,
  [INIT_CHECKOUT_STATE]: initCheckoutState,
  [SET_CARPROFILE]: setCarProfile,
  [SET_MOTORPROFILE]: setMotorProfile,
  [SET_TRAVELFILTER_FORM]: setTravelFilterForm,
  [SET_ACCIDENTFILTER_FORM]: setAccidentFilterForm,
  [SET_PETFILTER_FORM]:setPetFilterForm,
  [SET_VACCINEFILTER_FORM]:setVaccineFilterForm,
  [SET_INSUPERIOD]: setInsuPeriod,
  [SET_INSUINFOS]: setInsuInfos,
  [SET_CAR_CHECKOUT_INFO]: setCarCheckoutInfo,
  [SET_MOTOR_CHECKOUT_INFO]: setMotorCheckoutInfo,
  [SET_TRAVEL_CHECKOUT_INFO]: setTravelCheckoutInfo,
  [SET_ACCIDENT_CHECKOUT_INFO]: setAccidentCheckoutInfo,
  [SET_VACCINE_CHECKOUT_INFO]: setVaccineCheckoutInfo,
  [SET_PET_CHECKOUT_INFO]: setPetCheckoutInfo,
  [SET_CHECKOUT_QUOTE_OFCAR]: setCheckoutQuoteOfCar,
  [SET_CHECKOUT_QUOTE_OFTRAVEL]: setCheckoutQuoteOfTravel,
  [SET_CHECKOUT_QUOTE_OFACCIDENT]: setCheckoutQuoteOfAccident,
  [SET_CHECKOUT_QUOTE_OFPET]:setCheckoutQuoteOfPet,
  [SET_CHECKOUT_QUOTE_OFVACCINE]:setCheckoutQuoteOfVaccine,
  [SET_CHECKOUT_PRODPOLICIES]: setCheckoutProdplicies,
}